/* PERF: batch all scrollWidth/clientWidth READS, then all class WRITES, inside one
     requestAnimationFrame so the browser performs a single layout instead of forcing a
     reflow on every card (the original interleaved read/write loop was a forced-reflow
     source flagged by PageSpeed). Calls are coalesced so the triggers + mutations can't
     stack. Visual result (which links get the .is-overflowing mask) is identical. */
  var coyOverflowQueued = false;
  function applyOverflowFade() {
    if (coyOverflowQueued) return;
    coyOverflowQueued = true;
    requestAnimationFrame(function () {
      coyOverflowQueued = false;
      var links = document.querySelectorAll(
        '.product-recommendations .full-unstyled-link, .products-tabs .full-unstyled-link'
      );
      var states = [];
      links.forEach(function (link) { states.push(link.scrollWidth > link.clientWidth); });
      links.forEach(function (link, i) { link.classList.toggle('is-overflowing', states[i]); });
    });
  }

  function observeContainer(selector) {
    var container = document.querySelector(selector);
    if (container) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) { applyOverflowFade(); break; }
        }
      }).observe(container, { childList: true, subtree: true });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    applyOverflowFade();
    observeContainer('.product-recommendations');
    observeContainer('.products-tabs');
  });

  window.addEventListener('load', applyOverflowFade);

/* ============================================================================
   Appended 15 AUG — gallery nav idle fade, pairs with the block at the foot of
   coy-product-overflow-fade.css. Wrapped in its own guarded IIFE because the code
   above declares globals at top level and this must not add more.
   Delete from this banner to the end of the file to roll it back.
   ============================================================================ */
(function () {
  if (window.__coyGalleryGlassInit) return;
  window.__coyGalleryGlassInit = true;

  /* ---------- 3. PRODUCT GALLERY NAV — IDLE FADE (15 AUG) ----------
     The prev/next discs fade out once the gallery has been sitting still and fade back
     on the next swipe, then keep repeating: every wake reschedules the sleep, so the
     cycle runs for the life of the page rather than firing once.

     Three things this has to survive, which is why it is not just a timer on one node:
       - Shopify re-renders the media gallery on a variant change, so the nav element the
         listeners were bound to is thrown away. Input is delegated on document and the
         body observer re-registers whatever nav exists now.
       - The lightbox builds its own slider, often after this runs. Same rescan picks it up.
       - Swiper exposes no DOM event for a slide change, but it rewrites the wrapper's
         inline transform on every drag frame and every jump — observing that one attribute
         catches swipes, thumbnail taps and programmatic moves with a single hook.

     The class goes on .product__slider-nav, never on the buttons: Swiper owns button
     opacity through .swiper-button-disabled, and two owners on one property is how you
     get a disc stuck invisible at the end of the gallery. The two states live at the
     foot of coy-product-overflow-fade.css. Reduced motion opts out entirely and
     leaves the discs on. */
  (function(){
    'use strict';

    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var IDLE_MS  = 3000;
    var registry = new WeakMap();

    function sleep(nav){
      nav.classList.add('coy-nav-idle');
    }

    function wake(nav){

      var st = registry.get(nav);
      if(!st) return;

      nav.classList.remove('coy-nav-idle');

      clearTimeout(st.timer);
      st.timer = setTimeout(function(){ sleep(nav); }, IDLE_MS);
    }

    function watchWrapper(nav, st){

      var zone = nav.parentElement;
      if(!zone) return;

      var wrap = zone.querySelector('.swiper-wrapper');
      if(!wrap || wrap === st.wrap) return;

      if(st.mo) st.mo.disconnect();

      st.wrap = wrap;
      st.mo   = new MutationObserver(function(){ wake(nav); });

      st.mo.observe(wrap, { attributes:true, attributeFilter:['style'] });
    }

    function scan(){

      document.querySelectorAll('.product__slider-nav').forEach(function(nav){

        var st = registry.get(nav);

        if(st){

          watchWrapper(nav, st);

        }else{

          st = { timer:null, mo:null, wrap:null };
          registry.set(nav, st);

          watchWrapper(nav, st);
          wake(nav);
        }

      });
    }

    [
      'pointerdown','pointermove','touchstart','touchmove','click','keydown','focusin'
    ].forEach(function(type){

      document.addEventListener(type, function(e){

        var target = e.target;
        if(!target || !target.closest) return;

        var zone = target.closest('.product__media-list-wrapper, .product-media-modal');
        if(!zone) return;

        var nav = zone.querySelector('.product__slider-nav');
        if(nav) wake(nav);

      }, { capture:true, passive:true });

    });

    var rescan;

    new MutationObserver(function(){

      clearTimeout(rescan);
      rescan = setTimeout(scan, 150);

    }).observe(document.documentElement, { childList:true, subtree:true });

    if(document.readyState === 'loading'){

      document.addEventListener('DOMContentLoaded', scan);

    }else{

      scan();

    }

  })();
})();